import { Link, useLocation } from "react-router-dom";

import Container from "@mui/material/Container";

import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";
import SeoHead from "studio-edifique/components/SeoHead";

function NotFoundPage() {
  const { pathname } = useLocation();

  return (
    <>
      <SeoHead
        title="Página não encontrada"
        description="A página que você procura não foi encontrada. Conheça o Studio Edifique ou acesse nosso blog."
        keywords={[]}
        path={pathname}
        noIndex
      />
      <MKBox component="main" minHeight="100vh" display="grid" py={8} sx={{ placeItems: "center" }}>
        <Container maxWidth="sm">
          <MKTypography variant="button" color="info" fontWeight="bold">
            Studio Edifique · Erro 404
          </MKTypography>
          <MKTypography variant="h2" component="h1" mt={2} mb={2}>
            Página não encontrada
          </MKTypography>
          <MKTypography variant="body1" color="text" mb={4}>
            O endereço pode ter mudado ou a página pode não existir. Continue pela página inicial ou
            encontre outros conteúdos no blog.
          </MKTypography>
          <MKBox display="flex" flexWrap="wrap" gap={2}>
            <MKButton component={Link} to="/" color="info" variant="gradient">
              Ir para o início
            </MKButton>
            <MKButton component={Link} to="/blog" color="dark" variant="outlined">
              Acessar o blog
            </MKButton>
          </MKBox>
        </Container>
      </MKBox>
    </>
  );
}

export default NotFoundPage;
